import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/header';
import Home from './pages/home';
import Insights from './pages/insights';
import InsightDetails from './pages/insightdetails';
import Services from './pages/services';
import Team from './pages/team';
import Contact from './pages/contact';
import Footer from './components/footer';
import ScrollToTop from './components/scrollToTop';

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <main className="min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightDetails />} />
          <Route path="/insights-details" element={<InsightDetails />} />
          <Route path="/team" element={<Team />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/expertise" element={<Services />} />
          {/* <Route path="/regulatory-consulting" element={<Services />} />
          <Route path="/innovation-consulting" element={<Services />} />
          <Route path="/fractional-c-suite" element={<Services />} />
          <Route path="/infrastructure-build" element={<Services />} /> */}
          
        </Routes>
      </main>
      <Footer />
    </Router>
  );
};

export default App;
